function Button(props: ButtonProps) {
    const generalClassName = "button rounded-lg mx-5 font-semibold transition-colors";
    const colorClassName = props.color === "primary" ? 
                                "bg-blue-500 hover:bg-blue-700 text-white" 
                                : 
                            props.color === "secondary" ? 
                                "bg-blue-50 text-blue-600 hover:bg-slate-200 hover:text-blue-800" 
                                : 
                            props.color === "outline" ? 
                                "bg-transparent text-white border border-blue-500 border-solid hover:border-blue-700 hover:text-slate-200"
                                :
                                "bg-white hover:bg-gray-100 text-gray-800";

    const sizeClassName = props.size === "small" ?
                                "py-1.5 px-5 text-xs"   
                                :
                            props.size === "medium" ?
                                "py-1.5 px-5 text-sm"
                                :
                                "py-2 px-10 text-base";

    const className = generalClassName + " " + colorClassName + " " + sizeClassName + " " + props.className;

    return (
    <button className={className}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
        style={props.style}>
            <div className="flex justify-center">
                { props.icon && <i className={"iconoir-" + props.icon + " mr-2 pt-[4px]"}></i> }
                { props.text }
            </div>
    </button>
  )
}

export default Button;

interface ButtonProps {
    text?: string;
    color: "primary" | "secondary" | "outline";
    size: "small" | "medium" | "large";
    onClick?: () => void;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    style?: React.CSSProperties;
    icon?: string;
    className?: string;
}
